import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, useHistory } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { NotificationContainer } from 'react-notifications';
// styles
import './css/admin_style.min.css';
import './css/react-notifications.css';
import './css/captcha.min.css';
import './css/datepicker.css';
import './css/common.css';
import './css/yesh.css';
// utils
import App from './components/App';
import ModalComponent from './components/Base/Modal';
import { persistor, store } from './redux/store';
import rootSaga from './redux/sagas';
import interceptors from './services/interceptors';

console.log(
  `%cBuild version: ${process.env.REACT_APP_VERSION || 'localhost'}`,
  'color: #0B6623; background: #000; padding: 15px 50px; font-size: 16px;',
);

store.runSaga(rootSaga);

const Index = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  interceptors({ history, dispatch });
  return (
    <>
      <ModalComponent />
      <NotificationContainer />
      <App />
    </>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Index />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
